<template>
    <div class="giftCardList">
        <div class="kettlCards" v-if="gift_cards_list && !showCheckoutCheckBox">
            <router-link :to="{name: 'EditGiftCard',params: {cardId: gcard.card_id}}" class="card" v-for="(gcard, index) in gift_cards_list">
                <div class="closeIcon" @click.prevent="removeCard(index)">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.98026 0.971802C3.3956 0.971802 0.498047 3.8049 0.498047 7.30983C0.498047 10.8148 3.3956 13.6479 6.98026 13.6479C10.5649 13.6479 13.4625 10.8148 13.4625 7.30983C13.4625 3.8049 10.5649 0.971802 6.98026 0.971802ZM10.2214 9.58518L9.30738 10.4788L6.98026 8.20349L4.65315 10.4788L3.73915 9.58518L6.06627 7.30983L3.73915 5.03448L4.65315 4.14082L6.98026 6.41617L9.30738 4.14082L10.2214 5.03448L7.89425 7.30983L10.2214 9.58518Z"
                            fill="white"/>
                    </svg>
                </div>
                <div class="title h2">
                    {{ gcard.title }}
                </div>
                <div class="purchased caption">
                    Balance ${{ gcard.balance }}
                </div>
                <div class="username caption">
                    <div class="name">
                        {{ user.first_name}} {{ user.last_name }}
                    </div>
                    <div class="points">
                        {{ gcard.card_number }}
                    </div>
                </div>
            </router-link>
        </div>
        <router-link :to="{name: 'AddGift'}" class="addcard">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 5.55646H9V9.65242H5V11.7004H9V15.7963H11V11.7004H15V9.65242H11V5.55646ZM10 0.436523C4.48 0.436523 0 5.02399 0 10.6764C0 16.3288 4.48 20.9163 10 20.9163C15.52 20.9163 20 16.3288 20 10.6764C20 5.02399 15.52 0.436523 10 0.436523ZM10 18.8683C5.59 18.8683 2 15.1922 2 10.6764C2 6.16062 5.59 2.4845 10 2.4845C14.41 2.4845 18 6.16062 18 10.6764C18 15.1922 14.41 18.8683 10 18.8683Z"
                    fill="#CF3339"/>
            </svg>
            <span class="h4">Add a Gift Card</span>
        </router-link>
        <div class="giftCartBalance" v-if="total && showCheckoutCheckBox">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="balance">
                            <div class="h4">You have a gift card balance of $<span>{{ total.toFixed(2) }}</span>!</div>
                            <div class="usegiftpoints custom-control custom-checkbox">
                                <input type="checkbox" :checked="cart.giftCards" class="custom-control-input" name="useGift" id="giftBal" @change="toggleGiftCards">
                                <label class="custom-control-label" for="giftBal">Apply gift card balance</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GiftCardsList",
        props: ["showCheckoutCheckBox"],
        data() {
            return {
                gift_cards: {total: 0, ids: [], cvv: []},
                gift_cards_list: [],
            }
        },
        created() {
            if(this.user) {
                this.$store.dispatch("cart/getGiftCards", {
                    callback: (data) => {
                        this.gift_cards_list = data;
                        if(!this.gift_cards){
                            this.gift_cards = {total: 0, ids: [], cvv: []};
                        }
                    }
                });
            }else{
                if(this.$store.state.cart.cart.guestGiftCardList){
                    this.gift_cards_list = this.$store.state.cart.cart.guestGiftCardList;
                }
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart.cart;
            },
            total() {
                let total = 0;
                this.gift_cards_list?.map(gc => {
                    total += parseFloat(gc.balance);
                });
                return total;
            }
        },
        methods: {
            removeCard(index) {
                this.$modal.show("promt-modal", {
                    title: "Warning!", content: "Are you sure you want to remove this card?", success: () => {
                        this.$store.dispatch("giftcard/deleteGiftCard", {
                                    id: this.gift_cards[index].card_id,
                                    callback: () => {
                                        this.gift_cards.splice(index, 1);
                                    }
                                }
                        );
                    }
                })
            },
            toggleGiftCards(){
                if (this.cart.giftCards){
                    this.$store.commit("cart/setGiftCards", null );
                    this.gift_cards = {total: 0, ids: [], cvv: []};
                }else{
                    this.$store.commit("cart/setGiftCards", this.gift_cards);
                    if (this.gift_cards_list.length && this.gift_cards.ids.length === 0){
                        this.gift_cards_list.map(el=>{
                            this.gift_cards.total += parseFloat(el.balance);
                            this.gift_cards.ids.push(el.card_id);
                            this.gift_cards.cvv.push(el.cvv);
                        });
                    }
                }
            }
        }
    }
</script>
